import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart } from "../../../redux/actions/cartActions";
import { removeFromCompare } from "../../../redux/actions/compareActions";
import { getDiscountPrice } from "../../../helpers/product";
import { buildDynamicLinkForRef, constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import { decodeText } from "../../../utils/richText";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import Image from "../../../components/magnolia/image/Image";
import LinkWrapper from "../../../components/magnolia/linkWrapper/LinkWrapper";
import Rating from "../../../components/magnolia/productList/sub-components/ProductRating";

// Magnolia twin of flone's pages/other/Compare. It renders inside BaseLayout, which already
// provides the shop's header and footer, so there is no LayoutOne here (that gave the page a
// second, flone-branded header). Product links, images and names follow the Cart page.
const Compare = ({ cartItems, compareItems, addToCart, removeFromCompare, currency }) => {
    const shopLink = constructArtificialLinkNode({ value: getStaticPageLink("HOME") });

    return (
        <Fragment>
            <HtmlHeader title="Compare" />
            <Breadcrumb />

            <div className="compare-main-area pt-90 pb-100">
                <div className="container">
                    {compareItems && compareItems.length >= 1 ? (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="compare-page-content">
                                    <div className="compare-table table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <tbody>
                                                <tr>
                                                    <th className="title-column">Product Info</th>
                                                    {compareItems.map((compareItem, key) => {
                                                        const cartItem = cartItems.filter((item) => item.id === compareItem.id)[0];
                                                        const productLinkNode = constructArtificialLinkNode({
                                                            value: buildDynamicLinkForRef("PRODUCT_DETAIL", compareItem),
                                                        });

                                                        return (
                                                            <td className="product-image-title" key={key}>
                                                                <div className="compare-remove">
                                                                    <button onClick={() => removeFromCompare(compareItem)}>
                                                                        <i className="pe-7s-trash" />
                                                                    </button>
                                                                </div>
                                                                {compareItem.image && compareItem.image[0] && (
                                                                    <LinkWrapper linkNode={productLinkNode} linkClass="image">
                                                                        <Image imageNode={compareItem.image[0]} className="img-fluid" />
                                                                    </LinkWrapper>
                                                                )}
                                                                <div className="product-title">
                                                                    <LinkWrapper linkNode={productLinkNode}>{decodeText(compareItem.displayName)}</LinkWrapper>
                                                                </div>
                                                                <div className="compare-btn">
                                                                    {compareItem.affiliateLink ? (
                                                                        <a href={compareItem.affiliateLink} rel="noopener noreferrer" target="_blank">
                                                                            {" "}
                                                                            Buy now{" "}
                                                                        </a>
                                                                    ) : compareItem.variation && compareItem.variation["@nodes"].length >= 1 ? (
                                                                        <LinkWrapper linkNode={productLinkNode}>Select Option</LinkWrapper>
                                                                    ) : compareItem.stock && compareItem.stock > 0 ? (
                                                                        <button
                                                                            onClick={() => addToCart(compareItem)}
                                                                            className={cartItem !== undefined && cartItem.quantity > 0 ? "active" : ""}
                                                                            disabled={cartItem !== undefined && cartItem.quantity > 0}
                                                                            title={cartItem !== undefined ? "Added to cart" : "Add to cart"}
                                                                        >
                                                                            {cartItem !== undefined && cartItem.quantity > 0 ? "Added" : "Add to cart"}
                                                                        </button>
                                                                    ) : (
                                                                        <button disabled className="active">
                                                                            Out of Stock
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                <tr>
                                                    <th className="title-column">Price</th>
                                                    {compareItems.map((compareItem, key) => {
                                                        const discountedPrice = getDiscountPrice(compareItem.price, compareItem.discount);
                                                        const finalProductPrice = (compareItem.price * currency.currencyRate).toFixed(2);
                                                        const finalDiscountedPrice = (discountedPrice * currency.currencyRate).toFixed(2);

                                                        return (
                                                            <td className="product-price" key={key}>
                                                                {discountedPrice !== null ? (
                                                                    <Fragment>
                                                                        <span className="amount old">{currency.currencySymbol + finalProductPrice}</span>
                                                                        <span className="amount">{currency.currencySymbol + finalDiscountedPrice}</span>
                                                                    </Fragment>
                                                                ) : (
                                                                    <span className="amount">{currency.currencySymbol + finalProductPrice}</span>
                                                                )}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>

                                                <tr>
                                                    <th className="title-column">Description</th>
                                                    {compareItems.map((compareItem, key) => (
                                                        <td className="product-desc" key={key}>
                                                            <p>{compareItem.shortDescription ? decodeText(compareItem.shortDescription) : "N/A"}</p>
                                                        </td>
                                                    ))}
                                                </tr>

                                                <tr>
                                                    <th className="title-column">Rating</th>
                                                    {compareItems.map((compareItem, key) => (
                                                        <td className="product-rating" key={key}>
                                                            <Rating ratingValue={compareItem.rating} />
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item-empty-area text-center">
                                    <div className="item-empty-area__icon mb-30">
                                        <i className="pe-7s-shuffle"></i>
                                    </div>
                                    <div className="item-empty-area__text">
                                        No items found in compare <br />{" "}
                                        <LinkWrapper linkNode={shopLink}>Add Items</LinkWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

Compare.propTypes = {
    addToCart: PropTypes.func,
    cartItems: PropTypes.array,
    compareItems: PropTypes.array,
    currency: PropTypes.object,
    removeFromCompare: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        cartItems: state.cartData,
        compareItems: state.compareData,
        currency: state.currencyData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, quantityCount) => {
            dispatch(addToCart(item, quantityCount));
        },
        removeFromCompare: (item) => {
            dispatch(removeFromCompare(item));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Compare);